import { Component, ElementRef } from '@angular/core';
import { MapTooltipComponent } from '../map-tooltip/map-tooltip.component';
import { MapTooltipContent, MapTooltipLevelType } from '../map-tooltip/map-tooltip.types';

@Component({
  selector: 'app-sku-map-tooltip',
  templateUrl: './sku-map-tooltip.component.html',
  styleUrls: ['../map-tooltip/map-tooltip.component.scss']
})
export class SkuMapTooltipComponent extends MapTooltipComponent<MapTooltipContent> {

  constructor(protected override elementRef: ElementRef) {
    super(elementRef);
  }

  isEmpty(): boolean {
    return !this.content || this.content.empty;
  }
} 